import React, { useMemo } from 'react';
import orderBy from 'lodash/orderBy';
import { List } from 'antd';
import Option from '../Option';
import OptionIcon from './OptionIcon';
import OptionAvatar from './OptionAvatar';
import OptionListItem from './OptionListItem';
import TextMessage from '../TextMessage';

interface OptionsListProps {
  message: string;
  options: {
    id: number | string;
    name: string;
    title?: string;
    icon?: string;
    action?: string;
    titleExtra?: string;
    description?: string;
  }[];
  // eslint-disable-next-line no-unused-vars
  onSelection: (_: { name: string, action?: string }) => void;
  showOptionChildren?: boolean;
  languageCode?: string;
  showOptions?: boolean;
  orderKey?: string;
  readOnly?: boolean;
}

const OptionsList = function ({
  message,
  options,
  onSelection,
  showOptionChildren = true,
  languageCode = 'en',
  showOptions = true,
  orderKey = undefined,
  readOnly = false,
}: OptionsListProps) {
  const orderedOptions = useMemo(
    () => (orderKey ? orderBy(options, orderKey) : options),
    [options, orderKey],
  );
  return (
    <>
      <TextMessage>{message}</TextMessage>
      {showOptions && (
        <div className="message-options">
          <ul className="message-options-list">
            {orderedOptions.map((option) => (
              <div key={option.id}>
                {option?.titleExtra && (
                  <div style={{ marginTop: '15px' }}>
                    <TextMessage>
                      {option.titleExtra}
                    </TextMessage>
                  </div>
                )}
                <Option
                  key={option.id}
                  id={option.action ?? option.id}
                  name={option.name || option.title || option.description}
                  onClick={() => (!readOnly ? onSelection(option) : undefined)}
                  locale={languageCode}
                  $disabled={readOnly}
                  $highlighted={option?.id === 'expertFallback'}
                >
                  {showOptionChildren ? (
                    <OptionListItem description={option.description}>
                      <List.Item.Meta
                        avatar={option.icon ? (
                          <OptionAvatar>
                            <OptionIcon icon={option.icon} />
                          </OptionAvatar>
                        ) : undefined}
                        title={option.name}
                        description={option.description}
                      />
                    </OptionListItem>
                  ) : null}
                </Option>
              </div>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default OptionsList;
